import { render } from "./ShowLookupKey.vue?vue&type=template&id=970b9794"
import script from "./ShowLookupKey.vue?vue&type=script&lang=js"
export * from "./ShowLookupKey.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__